import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../theme";
import { CheckCircle } from "lucide-react";

interface Plan {
  name: string;
  price: string;
  features: string[];
  popular?: boolean;
}

const plans: Plan[] = [
  {
    name: "Free",
    price: "€0 / month",
    features: [
      "Play with up to 3 players",
      "Basic scoring system",
      "Access to standard categories",
    ],
  },
  {
    name: "Pro",
    price: "€4.99 / month",
    features: [
      "Play with up to 8 players",
      "Advanced scoring system",
      "Exclusive categories",
      "Priority support",
    ],
    popular: true,
  },
  {
    name: "Premium",
    price: "€9.99 / month",
    features: [
      "Unlimited players",
      "All categories unlocked",
      "Custom game modes",
      "Early access to new features",
      "Priority support",
    ],
  },
];

const Subscriptions = () => {
  const { colors } = useContext(ThemeContext)!;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <div className={`min-h-screen ${colors.bgSecondaryColor}`}>
      <div className="container mx-auto px-6 py-4 md:py-20 max-w-6xl">
        <div
          className={`text-center transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
        >
          <h1 className={`text-4xl md:text-5xl font-bold ${colors.textColor} mb-4`}>
            Choose Your Plan
          </h1>
          <p className={`${colors.textColor} opacity-70 mb-12`}>
            Unlock new features, compete with more players, and get the most out of I Call On.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-2xl p-8 shadow-lg border ${colors.borderColor
                } ${colors.cardBg} transform transition-all hover:scale-105`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                  Most Popular
                </div>
              )}
              <h2 className={`text-2xl font-bold ${colors.textColor} mb-2`}>
                {plan.name}
              </h2>
              <p className={`text-xl font-semibold ${colors.textColor} mb-4`}>
                {plan.price}
              </p>
              <ul className="mb-6 space-y-2">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className={`flex items-center gap-2 ${colors.textColor} opacity-80`}>
                    <CheckCircle className="h-5 w-5 text-green-500" />
                    {feature}
                  </li>
                ))}
              </ul>
              <button
                className="w-full rounded-xl bg-blue-600 text-white px-6 py-3 font-medium hover:bg-blue-700 transition"
              >
                Select
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className={`${colors.textColor} opacity-70`}>
            All subscriptions are billed monthly. You can cancel anytime.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Subscriptions;
